<template>
  <v-row align="center" justify="space-around">
    <v-col cols="12" lg="6">
      <!-- Row for Duration, Days, and Map -->
      <!-- <v-row> -->
      <!-- Col for Duration, Days and Times -->
      <!-- <v-col
          v-if="
            eventDetails.Type === 'Repetitive' ||
            eventDetails.Type === 'Tour' ||
            eventDetails.Type === 'Fixed'
          "
          class="d-flex d-md-block flex-row flex-md-column"
          cols="12"
          md="6"
        >
          <v-col class="pa-0" cols="6" md="12">
            <p class="mb-0">
              <b>{{ $translate('STARTING_AT') }}:</b>
            </p>
            <p>{{ getMinTicketPrice() }}</p>
            <p style="margin-bottom: 0 !important">
              <b>{{ $translate('EVENT_DURATION_EC') }}:</b>
            </p>
            <p>{{ readableDuration() }}</p>
          </v-col>
          <v-col
            v-if="
              eventDetails.hasOwnProperty('BatchGroupInfo') &&
              eventDetails.Type !== 'Webshop'
            "
            class="pa-0"
            cols="6"
            md="12"
          >
            <p style="margin-bottom: 0 !important">
              <b>{{ $translate('AVA_DAYS') }}:</b>
            </p>
            <p>{{ eventDetails.BatchGroupInfo.Days }}</p>
            <p style="margin-bottom: 0 !important">
              <b>{{ $translate('TIMES') }}:</b>
            </p>
            <p>{{ eventDetails.BatchGroupInfo.Times }}</p>
          </v-col>
          <v-col
            v-if="eventDetails.Type === 'OrderEvent'"
            class="pa-0"
            cols="6"
            md="12"
          >
            <p class="mb-0">
              <b>{{ $translate('EVENT_PRICE_INFORMATION') }}:</b>
            </p>
            <template v-for="item in eventDetails.PriceCategories">
              <p>{{ item.Name }}: €{{ item.Price }}</p>
            </template>
          </v-col>
        </v-col> -->

      <!-- </v-row> -->

      <!-- Disable crowdness graph temparorily -->
      <template v-if="eventDetails.BatchGroupInfo != null">
        <!-- Row for Planboard Title -->
        <v-row class="mt-4">
          <v-col>
            <h1 class="primary--text">
              {{ $translate('EVENT_GRAPH_DETAILS') }}
            </h1>
            <span>{{ $translate('EVENT_CHART_EXPLANATION') }}</span>
          </v-col>
        </v-row>

        <!-- Row for StartDate and Location Selection -->
        <v-row justify="space-between">
          <!-- Col for Date Selection -->
          <v-col cols="12" md="6">
            <v-menu
              v-if="startDates.length > 0"
              ref="dateMenu"
              :close-on-content-click="true"
              v-model="dateMenu"
              :nudge-right="40"
              :return-value.sync="selectedStartDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-on="on"
                  v-bind="attrs"
                  v-model="selectedStartDateDMY"
                  :label="$translate('EVENT_GRAPH_DATE_PICKER')"
                  hide-details
                  append-icon="event"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                :allowed-dates="allowedStartDates"
                :events="allowedStartDates"
                @change="getPlanboard"
                color="primary"
                v-model="selectedStartDate"
                @input="$refs.dateMenu.save(selectedStartDate)"
                no-title
              />
            </v-menu>
          </v-col>
          <!-- Col for Location Selection -->
          <v-col cols="12" md="6">
            <v-select
              @change="getStartDates"
              :items="allLocations"
              v-model="selectedLocation"
              item-text="LocationName"
              return-object
              persistent-hint
              :label="$translate('CHOOSE_A_LOCATION')"
            ></v-select>
          </v-col>
          <!-- Col for Delivery Type Selection -->
          <v-col v-if="eventDetails.Type === 'OrderEvent'" cols="12" md="6">
            <v-select
              @change="getPlanboard"
              :items="deliveryTypes"
              v-model="selectedDeliveryType"
              persistent-hint
              :label="$translate('SELECT_ORDERTYPE')"
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <!-- Row for Planboad Graph -->
        <v-row justify="center" class="ma-0">
          <canvas v-if="hasPlaboard" id="crowdednessChart" />
          <div v-else class="text-center text--secondary">
            {{ $translate('NO_BOOKINGS_YET') }}
          </div>
        </v-row>
      </template>
    </v-col>
    <!-- Event location Map -->
    <v-col cols="12" lg="6">
      <h1 class="primary--text">
        {{ $translate('EVENT_LOCATION_MAP') }}
      </h1>
      <v-card>
        <v-row class="my-0">
          <v-col class="pa-0" cols="12" md="4">
            <v-row class="pt-2 px-6 my-0">
              <v-col class="pa-0 text-center" cols="6" md="12">
                <v-icon color="primary">place</v-icon>
                <p class="mb-0">{{ eventDetails.Location.Street }}</p>
                <p class="mb-0">{{ eventDetails.Location.PostalCode }}</p>
                <p class="mb-4">{{ eventDetails.Location.City }}</p>
              </v-col>
              <v-col class="pa-0 text-center" cols="6" md="12">
                <v-icon justify-self="center" color="primary"
                  >local_phone
                </v-icon>
                <p class="mb-0">{{ eventDetails.Location.Telephone }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 px-3" cols="12" md="8">
            <Map
              ref="eventDetailMap"
              :settings="eventDetailMapSettings"
              @readyToInitializeMap="initMap"
            ></Map>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import doRequest from '@/api/dssRequest';
import utility from '@/shared/utility';
import Map from '@/components/generalComponents/map/Map';
import MapObject from '@/objects/MapObject';
import Chart from 'chart.js';

export default {
  name: 'EventDetailsInfo',
  props: {
    eventDetails: Object,
  },
  components: {
    Map,
  },
  computed: {
    listOfLocations() {
      return this.$store.getters['locations/getLocations'];
    },
    selectedStartDateDMY() {
      return utility.dateFromYMDToDMY(this.selectedStartDate);
    },
  },
  watch: {
    listOfLocations() {
      this.getLocationDetails();
    },
  },
  data() {
    return {
      allLocations: [],
      DELIVERY_TYPE_TAKEAWAY: 'TakeAway',
      DELIVERY_TYPE_DELIVERY: 'Delivery',
      fullDescription: false,
      deliveryTypes: [],
      selectedDeliveryType: '',
      locations: [],
      selectedLocation: {},
      startDates: [],
      selectedStartDate: '',
      dateMenu: '',
      locationDetails: {},
      eventDetailMapSettings: {
        name: 'eventDetailMap',
        view: {
          zoom: 18,
        },
        interactions: {
          doubleClickZoom: false,
          dragAndDrop: false,
          dragPan: false,
          keyboardPan: false,
          keyboardZoom: false,
          mouseWheelZoom: false,
          pointer: true,
          select: true,
        },
        controls: {
          zoomControls: false,
          filterOption: false,
        },
        style: 'width: 100%; height: 35vh;',
      },
      hasPlaboard: false,
      chartData: {},
      showButtons: true,
    };
  },
  mounted() {
    this.init();
    this.initMap();
  },
  methods: {
    init() {
      if (
        this.eventDetails.TakeAwayPossible != null &&
        this.eventDetails.TakeAwayPossible
      ) {
        this.deliveryTypes.push(this.DELIVERY_TYPE_TAKEAWAY);
      }
      if (
        this.eventDetails.DeliveryPossible != null &&
        this.eventDetails.DeliveryPossible
      ) {
        this.deliveryTypes.push(this.DELIVERY_TYPE_DELIVERY);
      }

      if (this.deliveryTypes.length > 0) {
        [this.selectedDeliveryType] = this.deliveryTypes;
      }
      if (!_.isEmpty(this.eventDetails.Location)) this.getLocationDetails();
    },
    initMap() {
      if (this.$refs.eventDetailMap == null) {
        return;
      }

      const features = [];
      const polylineArray = [];
      if (this.eventDetails.Type === 'Tour') {
        this.eventDetails.RouteAspect.DataFieldTable.PathPoints.forEach(
          (pathPoint) => {
            polylineArray.push([pathPoint.Longitude, pathPoint.Latitude]);
          }
        );
        this.eventDetails.Stops.forEach((stop, index) => {
          let dotFeature = MapObject.createDotMarker(
            {
              longitude: stop.Longitude,
              latitude: stop.Latitude,
              data: {},
            },
            '#3CAEA3',
            9,
            String(index),
            'white'
          );
          features.push(dotFeature);
        });
        const polylineFeature = MapObject.createPolyline(
          polylineArray,
          '#0000FF',
          3
        );
        features.push(polylineFeature);
        this.$refs.eventDetailMap.map.focusOnPolyline(polylineArray);
      } else {
        this.$refs.eventDetailMap.map.deleteLayer('detailMarker');
        features.push(
          MapObject.createCategoryMarker(this.eventDetails.Location)
        );
        this.$refs.eventDetailMap.map.focusOnCoordinate(
          [
            this.eventDetails.Location.Longitude,
            this.eventDetails.Location.Latitude,
          ],
          20
        );
      }
      const vectorSource = MapObject.createVectorSource(features);
      const vectorLayer = MapObject.createVectorLayer(
        'detailMarker',
        vectorSource
      );
      vectorLayer.setZIndex(100);
      this.$refs.eventDetailMap.map.addLayerOnMap(vectorLayer);
    },
    getLocationDetails() {
      // Get the location of event from store
      this.allLocations = this.eventDetails.Locations;
      this.locationDetails = this.allLocations.find(
        (location) => location.LocationId === this.eventDetails.LocationId
      );
      if (this.allLocations[0] !== undefined) {
        [this.selectedLocation] = this.allLocations;
        if (this.selectedLocation.LocationId == null) {
          return;
        }
      } else {
        return;
      }
      const payload = {};
      doRequest(
        (response) => {
          if (Object.keys(response.data).length > 0) {
            this.selectedLocation = {};
            this.selectedLocation = response.data;
          }
          if (this.allLocations.length > 0) {
            this.getStartDates();
          }
        },
        () => {},
        'getLocationDetails',
        this.selectedLocation.LocationId,
        payload,
        'POST',
        600000,
        false
      );
    },
    getStartDates() {
      const currentDate = utility.getCurrentDateDMY();
      const payload = {
        OrderType: this.selectedDeliveryType,
        StartDate: currentDate,
        LocationId: this.selectedLocation.LocationId,
      };
      doRequest(
        (response) => {
          // Get all locations for this event
          if (response.data.AllLocations != null) {
            this.locations = response.data.AllLocations;
          }

          if (this.locations.length > 0) {
            [this.selectedLocation] = this.locations;
          }

          // Get available start dates
          if (response.data.Calendar != null) {
            Object.values(response.data.Calendar)
              .sort((a, b) => this.getDateObj(a) - this.getDateObj(b))
              .forEach((value) => {
                this.startDates.push(utility.dateFromDMYToYMD(value));
              });
          }

          if (this.startDates.length > 0) {
            [this.selectedStartDate] = this.startDates;
          }

          this.getPlanboard();
        },
        () => {},
        'getStartDates',
        this.eventDetails.EventId,
        payload
      );
    },
    getDateObj(dateStrDMY) {
      // Create Date object with date string received from backend, like 21-09-2020
      const dmyArray = dateStrDMY.split('-');
      const dateObj = new Date(+dmyArray[2], dmyArray[1] - 1, +dmyArray[0]);
      return dateObj;
    },
    getMinTicketPrice() {
      if (this.eventDetails.PriceCategories == null) return 0;

      let minPrice = Number.MAX_VALUE;
      let minFound = false;

      Object.values(this.eventDetails.PriceCategories).forEach((item) => {
        if (Number(item.Price) < minPrice) {
          minPrice = Number(item.Price);
          minFound = true;
        }
      });

      if (!minFound) {
        minPrice = 0;
      }

      return `€${minPrice.toFixed(2)}`;
    },
    readableDuration() {
      let durationInSec = 0;
      const durationFloat = Number.parseFloat(this.eventDetails.Duration);
      if (!Number.isNaN(durationFloat)) {
        durationInSec = durationFloat;
      }

      const time = Math.floor(durationInSec / 60);
      const hours = Math.floor(time / 60);
      const minutes = Math.floor(time % 60);

      if (hours > 0) {
        if (minutes > 0) {
          return `${hours} ${this.$translate('HOURS')} ${this.$translate(
            'AND'
          )} ${minutes} ${this.$translate('MINUTES')}`;
        }
        return `${hours} ${this.$translate('HOURS')}`;
      }

      return `${minutes} ${this.$translate('MINUTES')}`;
    },
    allowedStartDates(date) {
      return this.startDates.indexOf(date) !== -1;
    },
    getPlanboard() {
      /*
      This function is used to get all batches (time-slots) of an event,
      to show how busy it is between a certain start/end date
      */
      if (this.eventDetails.Type === 'Webshop') {
        return;
      }

      const date = new Date(); // for now
      const hours = date.getHours(); // => 9
      const minutes = date.getMinutes(); // =>  30
      let minutesStr = '';
      if (minutes.toString().length === 1) {
        minutesStr = `0${minutes.toString()}`;
      } else {
        minutesStr = minutes.toString();
      }
      const time = `${hours}:${minutesStr}`;
      const payload = {
        StartTime: String(time),
        EndTime: '00:00',
        StartDate: utility.dateFromYMDToDMY(this.selectedStartDate),
        EndDate: utility.dateFromYMDToDMY(this.selectedStartDate),
        OrderType: this.selectedDeliveryType,
        LocationId: this.selectedLocation.LocationId,
      };

      if (payload.StartDate == null || payload.EndDate == null) return;

      doRequest(
        (response) => {
          // if there's no data the chart won't be visible
          if (
            response.data.PlanBoard != null &&
            Object.keys(response.data.PlanBoard).length > 0
          ) {
            this.hasPlaboard = true;
          } else {
            this.hasPlaboard = false;
            return;
          }

          this.chartData = response.data;

          // the data of the chart: y = EventCapacity and x = TimeSlots
          const y = [];
          const x = [];
          Object.values(this.chartData.PlanBoard[0].TimeSlots).forEach(
            (item) => {
              y.push(item.EventOccupancy);
              x.push(item.Time);
            }
          );

          setTimeout(() => {
            const ctx = document.getElementById('crowdednessChart');
            const barChart = new Chart(ctx, {
              // The type of chart we want to create
              type: 'bar',

              // The data for our dataset
              data: {
                labels: x,
                datasets: [
                  {
                    label: utility.dateFromYMDToDMY(this.selectedStartDate),
                    backgroundColor: this.$vuetify.theme.primary,
                    borderColor: this.$vuetify.theme.primary,
                    data: y,
                  },
                ],
              },

              // Configuration options go here
              options: {
                scales: {
                  xAxes: [
                    {
                      display: true,
                      scaleLabel: {
                        display: true,
                      },
                    },
                  ],
                  yAxes: [
                    {
                      display: true,
                      ticks: {
                        beginAtZero: true,
                        steps: 0,
                        max: 100,
                        stepSize:
                          this.$vuetify.breakpoint.name === 'xs' ? 25 : 10,
                        callback(tick) {
                          return `${tick.toString()}%`;
                        },
                      },
                    },
                  ],
                },
              },
            });
          }, 10);
        },
        () => {},
        'getPlanBoard',
        this.eventDetails.EventId,
        payload
      );
    },
  },
};
</script>

<style scoped>
#crowdednessChart {
  max-height: 20em !important;
  width: auto;
}
</style>
